export default function replaceUnderscores(value) {
  if (value) {
    return value.replace(new RegExp('_', 'g'), ' ')
  }
}